import ProductDraftBulkCreate from "./ProductDraftBulkCreate";
import ProductIcon from "@mui/icons-material/Fastfood";

const productsDraft = {
  list: ProductDraftBulkCreate,
  edit: ProductDraftBulkCreate,
  show: ProductDraftBulkCreate,
  icon: ProductIcon,
};

export default productsDraft;
